import { Grid, SxProps, TextField, Theme } from '@mui/material';

import { GridSizeType, gridSize } from '@/shared';

export type CustomTextFieldNoFormProps = {
  label: string;
  required?: boolean;
  enableOnlyNumber?: boolean;
  type?: string;
  shrink?: boolean;
  disabled?: boolean;
  size?: GridSizeType;
  value?: string | number;
  defaultValue?: string | number;
  variant?: 'standard' | 'outlined' | 'filled';
  sxTextField?: SxProps<Theme>;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  onChangeCustom?:((e:React.ChangeEvent<HTMLInputElement>)=>void)
  actionEnter?:((e: React.KeyboardEvent<HTMLDivElement>)=>void)
  // Soporte para campos de texto multilínea (solo lectura o edición).
  multiline?: boolean;
  rows?: number;
  minRows?: number;
  maxRows?: number;
};

const CustomTextFieldNoForm: React.FC<CustomTextFieldNoFormProps> = ({
  label,
  value,
  defaultValue,
  type = 'text',
  shrink = false,
  disabled = false,
  required = true,
  enableOnlyNumber = false,
  size = gridSize,
  variant = 'outlined',
  sxTextField,
  startAdornment,
  endAdornment,
  onChangeCustom,
  actionEnter,
  multiline = false,
  rows,
  minRows,
  maxRows,
}) => {

  const handleKeyDownNumber = (event: React.KeyboardEvent<HTMLDivElement>) => {
    // Bloquear teclas no deseadas (e, E, -, .)
    if (['e', 'E', '-', '.'].includes(event.key)) {
      event.preventDefault();
    }
  };
  const handleKeyDownDetection = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (actionEnter && ['Enter'].includes(event.key)) {
      actionEnter(event);
    }
  };
  return (

    <Grid item {...size}>
      <TextField
        disabled={disabled}
        fullWidth
        variant={variant}
        label={label}
        value={value ?? defaultValue}
        defaultValue={defaultValue ?? ''}
        required={required}
        InputLabelProps={{
          ...(shrink && { shrink: true }),
          ...(startAdornment && { startAdornment }),
        }}
        autoComplete='off'
        autoCorrect='off'
        type={enableOnlyNumber ? "number" : type}
        inputProps={{ readOnly: disabled }}
        InputProps={{
          startAdornment: startAdornment ?? null,
          endAdornment: endAdornment ?? null,
        }}
        onKeyDown={(e) => enableOnlyNumber ? handleKeyDownNumber(e) : handleKeyDownDetection(e)}
        sx={{
          ...(disabled
            ? {
              "& .MuiOutlinedInput-root": {
                backgroundColor: "rgba(0, 0, 0, 0.035)",
                cursor: "not-allowed",
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(239, 239, 239, 0.16)",
                  borderStyle: "dashed",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "rgba(0, 0, 0, 0.22)",
                },
              },
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "rgba(15, 23, 42, 0.88)",
                color: "rgba(15, 23, 42, 0.88)",
                fontWeight: 600,
                cursor: "not-allowed",
              },
              "& .MuiInputLabel-root.Mui-disabled": {
                color: "text.secondary",
                fontWeight: 500,
              },
            }
            : {
              "& .MuiOutlinedInput-root": {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#d3d3d3",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#9395ec",
                },
              },
            }),
          ...sxTextField,
        }}
        onChange={onChangeCustom}
      />
    </Grid>

  );
};

export default CustomTextFieldNoForm;
